module.exports = __webpack_public_path__ + "static/media/CeraPro-Medium.12a8c3f8.woff";